<!-- eslint-disable vue/no-v-html -->
<template>
    <footer class="dhf-footer" :class="{ 'dhf-footer--minimal': minimal }">
        <div class="dhf-footer__inner">
            <div v-if="!minimal && data" class="dhf-footer__top-section">
                <div class="dhf-footer__top-section-sidebar">
                    <DhfForm
                        :data="data.mielePartner"
                        class="dhf-footer__top-section-sidebar-mielePartner"
                        :is-locator="true"
                    />

                    <div class="dhf-footer__top-section-sidebar-experienceCenter">
                        <p
                            class="dhf-footer__top-section-sidebar-experienceCenter-label"
                            v-html="data.experienceCenter.label"
                        ></p>
                        <ul v-if="isLinkList(data.experienceCenter.items)">
                            <li
                                v-for="(item, index) in data.experienceCenter.items"
                                :key="index"
                                class="dhf-footer__top-section-sidebar-experienceCenter-item"
                            >
                                <a
                                    v-if="item.isActive"
                                    :href="item.href"
                                    :target="item.target"
                                    :data-testId="`dhf-footer-experienceCenter-link-${index}`"
                                    @click="
                                        doFooterDataLayerPush(
                                            EventActionsFooter.experienceCenter,
                                            `${item.label} | ${item.href}`,
                                            item.href,
                                            item.label
                                        )
                                    "
                                    v-html="item.label"
                                ></a>
                            </li>
                        </ul>
                    </div>

                    <DhfForm
                        :data="data.newsletter"
                        class="dhf-footer__top-section-sidebar-newsletter"
                        :is-newsletter="true"
                    />

                    <div class="dhf-footer__top-section-contact">
                        <p class="dhf-footer__top-section-contact-label" v-html="data.contact.label"></p>
                        <ul class="dhf-footer__top-section-contact-numbersList">
                            <li v-for="(item, index) in data.contact.items" :key="index">
                                <a
                                    :href="item.type === 'phone' ? `tel:${item.value}` : `mailto:${item.value}`"
                                    @click="
                                        doFooterDataLayerPush(
                                            EventActionsFooter.contact,
                                            `${data?.contact.label} | ${item.value}`,
                                            item.value,
                                            data?.contact.label || ''
                                        )
                                    "
                                    v-html="item.value"
                                >
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div v-if="resolvedLanguageResources">
                        <p class="dhf-footer__top-section-language-label">
                            {{ ct('nav.language-label') }}
                        </p>
                        <ul class="dhf-footer__top-section-language" role="menu">
                            <li class="dhf-footer__top-section-language" role="menuitem">
                                <div class="dhf-footer__top-section-language-wrapper">
                                    <dhf-language-select
                                        v-if="resolvedLanguageResources"
                                        :language-resources="resolvedLanguageResources"
                                        :custom-class-list="'dhf-footer__top-section-language-dropdown'"
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="dhf-footer__top-section-categories">
                    <div
                        v-for="(category, index) in data.categories"
                        :key="index"
                        class="dhf-footer__top-section-categories-item"
                    >
                        <DhfAccordion :id="index.toString()" class="dhf-footer__top-section-categories-item-mobile">
                            <template #title>
                                <span
                                    class="dhf-footer__top-section-categories-item-label"
                                    v-html="category.label"
                                ></span>
                            </template>
                            <template #content>
                                <ul class="dhf-footer__top-section-categories-item-accordion-list">
                                    <li v-for="(item, i) in category.items" :key="i">
                                        <a
                                            :href="item.href"
                                            @click="
                                                doFooterDataLayerPush(
                                                    EventActionsFooter.footerLinks,
                                                    `${item.label} | ${item.href}`,
                                                    item.href || '',
                                                    item.label
                                                )
                                            "
                                            v-html="item.label"
                                        ></a>
                                    </li>
                                </ul>
                            </template>
                        </DhfAccordion>
                        <div class="dhf-footer__top-section-categories-item-desktop">
                            <p class="dhf-footer__top-section-categories-item-label" v-html="category.label"></p>
                            <ul>
                                <li v-for="(item, i) in category.items" :key="i">
                                    <a
                                        :href="item.href"
                                        @click="
                                            doFooterDataLayerPush(
                                                EventActionsFooter.footerLinks,
                                                `${item.label} | ${item.href}`,
                                                item.href || '',
                                                item.label
                                            )
                                        "
                                        v-html="item.label"
                                    ></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="!minimal" class="dhf-footer__divider" />

            <div v-if="data" class="dhf-footer__bottom-section">
                <div class="dhf-footer__bottom-section-legal">
                    <ul>
                        <li
                            v-for="(item, index) in data.legal"
                            :key="index"
                            class="dhf-footer__bottom-section-legal-item"
                        >
                            <a
                                v-if="item.isActive"
                                :id="item.id"
                                :href="item.href"
                                :target="item.target"
                                :data-testId="`dhf-footer-bootom-section-link-${index}`"
                                @click="
                                    doFooterDataLayerPush(
                                        EventActionsFooter.legal,
                                        `${item.label} | ${item.href}`,
                                        item.href,
                                        item.label
                                    )
                                "
                                v-html="item.label"
                            ></a>
                        </li>
                        <li v-if="showCookieSettingsLink" class="dhf-footer__bottom-section-legal-item">
                            <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
                        </li>
                        <li v-if="data.showDoNotSellMyInformationLink" class="dhf-footer__bottom-section-legal-item">
                            <button
                                class="not-sell-myinfo-button"
                                onclick="OneTrust.ToggleInfoDisplay();"
                                autocomplete="off"
                            >
                                {{ data.doNotSellMyInformationLabel }}
                            </button>
                        </li>
                    </ul>
                </div>

                <div class="dhf-footer__bottom-section-social">
                    <a
                        v-for="(item, index) in data.social"
                        :key="index"
                        :href="item.href"
                        :target="item.target"
                        :data-testId="`dhf-footer-social-${item.label}`"
                        @click="
                            doFooterDataLayerPush(
                                EventActionsFooter.social,
                                `${item.label} | ${item.href}`,
                                item.href,
                                item.label,
                                item.type
                            )
                        "
                    >
                        <DhfIcon v-if="item.isActive" :name="item.type" :title="item.label" area-hidden="true" />
                        <span class="sr-only">{{ item.label }}</span>
                    </a>
                </div>

                <ul class="dhf-footer__bottom-section-payment">
                    <li
                        v-for="(item, index) in data.payment"
                        :key="index"
                        :data-testId="`dhf-footer-payment-link-${item.label}`"
                    >
                        <img :src="item.url" :alt="item.label" loading="lazy" />
                    </li>
                </ul>
            </div>
        </div>
    </footer>

    <template v-if="data?.bnplFindomestic?.title || data?.bnplFindomestic?.message">
        <div class="dhf-footer__financing-section">
            <h4 class="dhf-footer__financing-section-title" v-html="data.bnplFindomestic.title"></h4>
            <p class="dhf-footer__financing-section-message" v-html="data.bnplFindomestic.message"></p>
        </div>
    </template>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue';
import type { FooterProps, ILanguageObject, ILanguageResources } from '@/types/shared-types';
import DhfAccordion from '@/components/dhf-accordion/dhf-accordion.vue';
import DhfForm from '@/components/dhf-form/dhf-form.vue';
import DhfIcon from '@/components/dhf-icon/dhf-icon.vue';
import { isLinkList } from '@/utils/isLinkList';
import { useTracking } from '@/composables/useTracking';
import useTranslations from '@/composables/useTranslations';
import DhfLanguageSelect from '@/components/dhf-language-select/dhf-language-select.vue';
import { useAlternateLanguage } from '@/composables/useAlternateLanguage';

const props = withDefaults(
    defineProps<{
        data: FooterProps | null;
        minimal: boolean;
        showCookieSettingsLink?: boolean;
        languageObject?: ILanguageObject | undefined;
    }>(),
    {
        showCookieSettingsLink: false,
        languageObject: undefined,
    }
);

const { EventActionsFooter, doFooterDataLayerPush } = useTracking();

const ct = useTranslations();

const resolvedLanguageResources = ref<ILanguageResources>();

onMounted(async () => {
    const languageSelect = useAlternateLanguage() ?? undefined;

    if (languageSelect) {
        if (!props.languageObject) {
            const { data } = languageSelect.useLanguageQuery();

            if (data.value) {
                resolvedLanguageResources.value = await languageSelect.getLanguageResources(data.value);
            }

            watch(data, async () => {
                try {
                    resolvedLanguageResources.value = await languageSelect.getLanguageResources(data.value);
                } catch (err) {
                    console.error(err);
                    throw err;
                }
            });
        } else if (props.languageObject && props.languageObject.languages?.length > 1) {
            resolvedLanguageResources.value = (await languageSelect.getLanguageResources(props.languageObject)) ?? null;

            watch([props], async () => {
                try {
                    resolvedLanguageResources.value =
                        (await languageSelect.getLanguageResources(props.languageObject)) ?? null;
                } catch (err) {
                    console.error(err);
                    throw err;
                }
            });
        }
    }
});
</script>

<style lang="scss">
@import './dhf-footer.scss';
</style>
